import { Component, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';

// Import's services:
import { ServicioCertificadoOcupacionalService, CertificadoServiceEntity } from 'src/app/services/servicio-certificado-ocupacional.service';
import { ServicioHistoriaService, HistoriaDatosEntity } from 'src/app/services/servicio-historia.service';
import { DataPermisosService } from 'src/app/services/utils/data-permisos.service';
import { FileService } from 'src/app/services/utils/file.service';
import { ServicioImagenesService, ObjetoImagenesEntity, ObjetoImagenesReponseEntity } from 'src/app/services/servicio-imagenes.service';

@Component({
  selector: 'app-historia-cenpresabil',
  templateUrl: './historia-cenpresabil.component.html',
  styleUrls: ['./historia-cenpresabil.component.css']
})
export class HistoriaCenpresabilComponent implements OnInit, OnChanges {

  private objetoService: CertificadoServiceEntity = {
    codigoBaseDatos : '',
    id : ''
  };

  private objetoImagenes: ObjetoImagenesEntity = {
    codigoBaseDatos : '',
    idEntidad : '',
    id : ''
  };

  private htmlReponse = '';

  public objetoEntity: HistoriaDatosEntity = {
    nombre : '',
    fechaAtencion : '',
    ciudadPatronal : '',
    empresa : '',
    tipoIdentificacion : '',
    numeroIdentificacion : '',
    fechaNacimiento : '',
    sexo : '',
    direccion : '',
    ciudadNacimiento : '',
    sector : '',
    nit : '',
    medicoAtencion : '',
    descripcionMedico : '',
    registroMedico : '',
    cargo : '',
    telefonoAfiliado : '',
    ciudadAfiliado : '',
    estadoCivil : '',
    eps : '',
    arl : '',
    afp : '',
    nivelEscolar : '',
    empleador : '',
    prosefion : ''
  };
  public objetoObservacionesEntity: ObjetoObservacionesEntity = {
    nombreMedico : '',
    registroMedico : '',
    firmaMedico : '',
    firmaPaciente : ''
  };

  public objetoPermisos: any = {
    imprimir: false,
    descargar: false,
    filtros: false
  };

  public objetoImagenesEntity: ObjetoImagenesReponseEntity = {
    id : '',
    fechaVersion : '',
    imagenFirma : '',
    imagenLogo : '',
    imagenAfiliado : ''
  };

  public datoValoracion = '';
  public mensajeError = '';
  public html: any = '';

  constructor( private servicioHistoria: ServicioHistoriaService,
               private dataPermisos: DataPermisosService,
               private servicioArchivo: FileService,
               private servicioImagenes: ServicioImagenesService,
               private activatedRoute: ActivatedRoute ) {
    this.activatedRoute.params.subscribe( params => {
      this.objetoService.codigoBaseDatos = params['codigoBaseDatos'];
      this.objetoService.id = params['id'];

      this.objetoImagenes.codigoBaseDatos = params['codigoBaseDatos'];
      this.objetoImagenes.idEntidad = params['idEntidad'];
      this.objetoImagenes.id = params['id'];
    });

    this.getPermisos();
  }

  ngOnChanges() {
    // tslint:disable-next-line: no-unused-expression
    this.html;
  }

  ngOnInit() {
    this.getResponse();
    this.getResponseHistoria();
    this.getResponseImagenes();
  }

  public async getPermisos() {
    const ruta: string = await this.activatedRoute.snapshot.url[0].path;
    const result: any = await this.dataPermisos.getPermisos(ruta);

    if (result != null) {
      this.objetoPermisos = result;
    }
  }

  private async getResponse() {
    try {
      const response = await this.servicioHistoria.getResponseHistoria(this.objetoService);

      if (response != null) {
        response.subscribe( (data: any) => {
          this.objetoEntity = data;

          this.objetoObservacionesEntity.nombreMedico = this.objetoEntity.medicoAtencion;
          this.objetoObservacionesEntity.registroMedico = this.objetoEntity.registroMedico;
        });
      }

    } catch (exception) {
      console.log(exception);
    }
  }

  private async getResponseHistoria() {
    try {
      const result = await this.servicioHistoria.getResponse( this.objetoService );

      if ( result != null ) {
        result.subscribe( (data: any) => {
          this.htmlReponse = data['body'];

          this.html = `
          <style>
            .table-report {
              border-collapse: collapse;
              font-size: 12px;
              border-top-width: 1px;
              border-left-width: 1px;
              border-top-style: solid;
              border-left-style: solid;
              border-top-color: #a8a8a8;
              border-left-color: #a8a8a8;
          }

          h4 {
            font-size: 15px;
            font-weight: bold;
          }

          .table-cell {
              border-bottom-width: 1px;
              border-right-width: 1px;
              border-bottom-style: solid;
              border-right-style: solid;
              border-bottom-color: #a8a8a8;
              border-right-color: #a8a8a8;
              border-collapse: collapse;
              text-align: center;
              font-weight: normal;
          }

          .table-cell-left {
              text-align: left;
          }

          .table-header-cell {
              background-color: #E5E2E2;
              font-weight: bold;
          }

          .table-cell-padding {
              padding: 2px 1px 2px 1px;
          }

          @page {
              size: A4;
          }

          @media print {
              .page {
                  margin: 1.5cm 1cm;
                  border: initial;
                  border-radius: initial;
                  width: initial;
                  min-height: initial;
                  box-shadow: initial;
                  background: initial;
                  page-break-after: always;
              }
              * {
                  page-break-before: avoid;
              }
              table {
                  page-break-inside: auto;
              }
              tr {
                  page-break-inside: avoid;
                  page-break-after: auto;
              }
          }

          html:BEFORE {
              content: "";
              color: rgba(128, 128, 128, 0.3);
              font-size: 15px;
              position: fixed;
              transform: rotate(-45deg);
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              margin: auto;
              text-align: center;
              height: 60px;
          }

          div {
              font-size: 12px;
          }

          .rs-panel-layout .pn-cell {
              vertical-align: top;
          }

          .rs-panel-layout .pn-row {
              height: 5px;
          }

          .rs-panel-layout .pn-head {
              width: 8.33%;
          }

          .condition-not-apply {
              color: #149bdf;
              font-weight: bold;
              text-transform: uppercase;
              font-size: 12px;
          }

          .col-orientation span {
              display: block;
              line-height: normal;
              text-transform: uppercase;
              text-align: center;
          }

          .title-odont {
              display: block;
              font-family: tahoma;
              font-size: 12px;
              font-weight: bold;
          }

          .teenth-report {
              text-align: center;
              width: 47px;
          }

          .out {
              background-color: #F92A01;
              color: white;
              border-color: #F92A01;
          }

          .not-val {
              background-color: #005DFF;
              color: white;
              border-color: #005DFF;
          }

          .ok {
              background-color: #038000;
              color: white;
              border-color: #038000;
          }

          .cell-sv {
              width: 51px;
              text-align: center;
              font-size: 12px;
              font-weight: bold;
          }
          </style>
          ${this.htmlReponse}
          `;
        });
      }

    } catch (exception) {
      console.log(exception);
    }
  }

  private async getResponseImagenes() {
    try {
      const result = await this.servicioImagenes.getResponseImagenes(this.objetoImagenes);

      if ( result != null ) {
        result.subscribe( (data: any) => {
          this.objetoImagenesEntity = data;
          this.objetoObservacionesEntity.firmaMedico = this.objetoImagenesEntity.imagenFirma;
          this.objetoObservacionesEntity.firmaPaciente = this.objetoImagenesEntity.imagenAfiliado;
        });
      }

    } catch (exception) {
      console.log(exception);
    }
  }

  public onGenerar( param: any ) {
    try {
      this.getResponse();
      this.getResponseHistoria();
      this.getResponseImagenes();
    } catch (exception) {
      console.log(exception);
    }
  }

  public onImprimir( param: any ) {

    let printContents: any, popupWin: any;

    printContents = document.getElementById('body-historia-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
              .table-report {
                border-collapse: collapse;
                font-size: 11px;
                border-top-width: 1px;
                border-left-width: 1px;
                border-top-style: solid;
                border-left-style: solid;
                border-top-color: #a8a8a8;
                border-left-color: #a8a8a8;
            }
            .table-cell {
                border-bottom-width: 1px;
                border-right-width: 1px;
                border-bottom-style: solid;
                border-right-style: solid;
                border-bottom-color: #a8a8a8;
                border-right-color: #a8a8a8;
                border-collapse: collapse;
                text-align: center;
                font-weight: normal;
            }
            .table-cell-left {
                text-align: left;
            }
            .table-header-cell {
                background-color: #E5E2E2;
                font-weight: bold;
            }
            .table-cell-padding {
                padding: 2px 1px 2px 1px;
            }
            @page {
                size: A4;
            }
            @media print {
                .page {
                    margin: 1.5cm 1cm;
                    border: initial;
                    border-radius: initial;
                    width: initial;
                    min-height: initial;
                    box-shadow: initial;
                    background: initial;
                    page-break-after: always;
                }
                * {
                    page-break-before: avoid;
                }
                table {
                    page-break-inside: auto;
                }
                tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }
            }
            html:BEFORE {
                content: "";
                color: rgba(128, 128, 128, 0.3);
                font-size: 50px;
                position: fixed;
                transform: rotate(-45deg);
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                text-align: center;
                height: 60px;
            }
            div {
                font-size: 11px
            }
            .rs-panel-layout .pn-cell {
                vertical-align: top;
            }
            .rs-panel-layout .pn-row {
                height: 5px;
            }
            .rs-panel-layout .pn-head {
                width: 8.33%;
            }
            .condition-not-apply {
                color: #149bdf;
                font-weight: bold;
                text-transform: uppercase;
                font-size: 11px;
            }
            .col-orientation span {
                display: block;
                line-height: normal;
                text-transform: uppercase;
                text-align: center;
            }
            .title-odont {
                display: block;
                font-family: tahoma;
                font-size: 11px;
                font-weight: bold;
            }
            .teenth-report {
                text-align: center;
                width: 47px;
            }
            .out {
                background-color: #F92A01;
                color: white;
                border-color: #F92A01;
            }
            .not-val {
                background-color: #005DFF;
                color: white;
                border-color: #005DFF;
            }
            .ok {
                background-color: #038000;
                color: white;
                border-color: #038000;
            }
            .cell-sv {
                width: 51px;
                text-align: center;
                font-size: 8pt;
                font-weight: bold;
            }
            body {
              font-family: 'Gentium Basic', serif;
            }

            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
    // let data =  xepOnline.Formatter.Html('body-historia-print',{resolution : '200'});
    // const html = `<html><head><meta charset="UTF-8"/></head><body>${data}</body></html>`;

    // let response = this.servicioArchivo.generatePDF(html, 'Historia Clínica', 'historiaclinica');

    // response.subscribe((data: any) => {
    //   let filename = data.filename;
    //   this.servicioArchivo.downloadFile(filename)
    //   .subscribe((data) =>{
    //     saveAs(data, filename);
    //   }, err => {
    //     this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
    //     console.error('Error download', err);
    //   })
    // }, (err: HttpErrorResponse) => {
    //   console.error('Error', err);
    //   this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
    // });
  }

  private mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 3500);
  }

}

interface ObjetoObservacionesEntity {
  nombreMedico: string;
  registroMedico: string;
  firmaMedico: string;
  firmaPaciente: string;
}
